import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, Grid, ListItem, Paper, Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
    card: {
        padding: theme.spacing(3),
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        marginTop: '-3%',
        marginBottom: '3.2%'
    },
    tableAction: {
        paddingLeft: 0,
        paddingRight: 0,
        margin: '0 auto',
        textAlign: 'center',
        alignItems: 'center'
    },
}));

export default function ListResponse({ rows, isLoadUser, handledEditQuestion, primaryColor }) {
    const classes = useStyles();

    const changeFormatDate = (date) => {
        let fecha = new Date(date);
        let año = fecha.getFullYear();
        let mes = fecha.getMonth() + 1;
        let day = fecha.getDate();
        mes = mes < 10 ? `0${mes}` : mes;
        day = day < 10 ? `0${day}` : day;
        fecha = `${año}-${mes}-${day}`;

        return fecha;
    };

    return (
        <>
            {isLoadUser ? (
                <Paper className={classes.card}>
                    <CircularProgress style={{ marginLeft: '60%' }} />
                </Paper>
            ) : (
                <>
                    {rows && rows.length > 0 && rows.map((row) => (
                        <Paper className={classes.card}>
                            <Grid container spacing={1}>
                                <Grid item xs={3} style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                    {changeFormatDate(row.created)}
                                </Grid>
                                <Grid  style={{ width:'36%',fontWeight: 'bold', fontSize: '16px' }}>
                                    {row.description}
                                </Grid>
                                <Grid style={{  width:'20%',fontWeight: 'bold', fontSize: '16px' }}>
                                    {row.status ? 'Activo' : 'Inactivo'}
                                </Grid>
                                <Grid item xs={1} onClick={() => handledEditQuestion(row)}>
                                    <ListItem button>
                                        <Tooltip title="Editar" aria-label="top-end">
                                            <EditIcon className={classes.tableAction} style={{ color: primaryColor }} />
                                        </Tooltip>
                                    </ListItem>
                                </Grid>
                            </Grid>
                        </Paper>
                    ))}
                </>
            )}
        </>
    );
}
